import cookies from "js-cookie";
import { Session } from "next-auth";

import { SESSION_COOKIE_NAME } from "../../../config/global.config";
import { jwtDecodeData } from "../../../helpers/jwtHelper";

const getAuthSession = () => {
    const jwt = cookies.get(SESSION_COOKIE_NAME);
    const session = jwt ? jwtDecodeData(jwt) : null;

    if (!session) return null;

    return session as Session;
};

export default getAuthSession;
